import { Component, OnInit, AfterViewInit, OnDestroy } from "@angular/core";
import {
    CclNavbarSecondaryService,
    CclDrawerService,
    CclMessageService,
    CclNavbarFooterService
} from "certain-common-library";
import { SharedService } from "../../../../../modules/shared/services/shared.service";
import { Subscription } from "rxjs";
import { CatalogService } from "../../../../../modules/shared/services/catalog.service";
import { FlashMessagesService } from "angular2-flash-messages";
import { cloneDeep } from "lodash";
import { UnsavedChangesDeactivate } from "../../../can-deactivate";

@Component({
    selector: "app-element-page",
    templateUrl: "./element-page.view.html",
    styleUrls: [],
    providers: [CatalogService]
})
export class ElementPageView extends UnsavedChangesDeactivate implements AfterViewInit, OnInit, OnDestroy {
    catalogLayoutConfig: any = {};
    subscription: Subscription;
    listStyle = '';

    constructor(
        private navSecondaryService: CclNavbarSecondaryService,
        public sharedService: SharedService,
        private messageService: CclMessageService,
        private navbarFooterService: CclNavbarFooterService,
        private catalogService: CatalogService,
        private _flashMessagesService: FlashMessagesService,
        private drawerService: CclDrawerService
    ) {
        super(sharedService);
        this.navSecondaryService.sectionLabel = "Define Layout";
        this.subscription = this.messageService.getMessage().subscribe((message) => this.saveElementConfig(message));
    }

    ngOnInit() {
        this.drawerService.closeMessage = null;
        this.catalogLayoutConfig = JSON.parse(this.sharedService.setup.layoutConfig);
        if(!this.catalogLayoutConfig.highlightedStyle &&
            !this.catalogLayoutConfig.promotedStyle &&
            !this.catalogLayoutConfig.generalStyle) {
                this.listStyle = 'list'
            }

        // For checking unsaved data
        this.sharedService.originalData = cloneDeep(this.catalogLayoutConfig);
        this.sharedService.changedData = this.catalogLayoutConfig;
    }

    saveElementConfig(message) {
        if (message.text == "save-element" || message.text == "save-next-element") {
            this.sharedService.setup.layoutConfig = JSON.stringify(this.catalogLayoutConfig);
            this.sharedService.setup.setupConfigs = null;
            this.catalogService.saveSetup(this.sharedService.setup).subscribe((resp) => {
                this.sharedService.catalogLayoutConfig = cloneDeep(this.catalogLayoutConfig);
                // For checking unsaved data
                this.sharedService.createCss(this.catalogService);
                this.sharedService.originalData = cloneDeep(this.catalogLayoutConfig);
                this.sharedService.changedData = this.catalogLayoutConfig;

                this.sharedService.setup = resp.body["sessionCatalogSetupDTO"];
                this._flashMessagesService.show("Layout saved successfully.", { cssClass: "alert-success" });
                if (message.text == "save-next-element") {
                    this.sharedService.catalogNavigateHelper("admin", "catalog/setting/theme");
                }
            });
        }
    }

    ngAfterViewInit(): void {
        if (this.navbarFooterService.navbar != null && this.navbarFooterService.navbar.rightNavbarItems != null) {
            this.navbarFooterService.navbar.rightNavbarItems[0].label = "NEXT STEP: Choosing a Theme";
            this.navbarFooterService.navbar.rightNavbarItems[1].message = "save-element";
            this.navbarFooterService.navbar.rightNavbarItems[2].message = "save-next-element";
        }
        this.messageService.sendMessage("update-publish-button");
    }

    ngOnDestroy(): void {
        this.sharedService.unsubscribeHelper(this.subscription);
    }

    toggleHtmlElement() {
        if (this.catalogLayoutConfig.htmlElement == null) {
            this.catalogLayoutConfig.htmlElement = true;
        }
        this.catalogLayoutConfig.htmlElement = !this.catalogLayoutConfig.htmlElement;
    }
}
